// The backend answers 401 when a token has expired, is invalid, or belongs to
// a user who has since been deactivated or deleted (403 means logged in but
// lacking the role). Either API client reports a 401 here, and main.js
// registers the handler that logs out and returns to the login screen. Kept
// as a callback so the clients don't import the store (which imports them).
export const isSessionExpiredResponse = (status, url) => status === 401 && !String(url || '').includes('/auth/login');

let handler = () => {};
let handling = false;

export const onUnauthorized = (fn) => {
  handler = fn;
};

// A page fires several requests at once, so several 401s arrive together;
// only the first one acts.
export const notifyUnauthorized = () => {
  if (handling) return;
  handling = true;
  handler();
  setTimeout(() => { handling = false; }, 2000);
};

export default { isSessionExpiredResponse, onUnauthorized, notifyUnauthorized };
